import classNames from "classnames";
import styles from "./ButtonGroup.module.css";
import uuid from "react-uuid";
import { useDeviceClassification } from "utils";
import { TButtonGroupProps } from "types";

export const ButtonGroup = ({
  alignment,
  buttons,
  className = "",
  ...props
}: TButtonGroupProps) => {

  const { isDesktop } = useDeviceClassification();

  /* Create button alignent config */
  const alignmentConfigFn = () => {
    const a = alignment?.Name.toLowerCase();
    const desktopValue = a?.split("and")[0];
    const mobileValue = a?.split("and")[1];

    return {
      desktopBtnAlignment: desktopValue?.includes("right") ? "right" : (desktopValue?.includes("centre") ? "centre" : "left"),
      mobileBtnAlignment: mobileValue?.includes("right") ? "right" : (mobileValue?.includes("centre") ? "centre" : "left"),
    }
  };

  const { desktopBtnAlignment = "left", mobileBtnAlignment = "left" } = alignmentConfigFn();

  return (
    <div className={classNames(styles.buttongroup, 'animateonscroll', className, isDesktop ?
      desktopBtnAlignment : mobileBtnAlignment)} {...props}>
      {buttons &&
        buttons.map(
          (
            {
              Text,
              Link: { Url, Target = "_self", Title },
              Type,
              ButtonId
            },
            i
          ) => {
            let splitButton = [];

            if (typeof Text === "string" && Text.includes("||")) {
              splitButton = Text.split("||");
            }

            return (
              <a
                id={ButtonId ? ButtonId : uuid()}
                key={`button-${i}`}
                className={classNames(
                  "button-2022",
                  Type?.CssClass,
                  splitButton.length > 0 && styles.expandobutton
                )}
                href={Url}
                target={Target}
                title={Title}
              >
                {/* if this is a normal text button */}
                {splitButton.length < 1 && Text}

                {/* if this is a button with an expanded hover */}
                {splitButton.length > 0 && (
                  <>
                    <span>{splitButton[0]}</span>
                    <span>
                      &nbsp;
                      {splitButton[1]}
                    </span>
                  </>
                )}
              </a>
            );
          }
        )}
    </div>
  );
};
